import type { Service } from "../types";
import { formatCurrency } from "../lib/format";
import { useCart } from "../lib/cart";
import { Button } from "./Button";

type ServiceCardProps = {
  service: Service;
};

export function ServiceCard({ service }: ServiceCardProps) {
  const cart = useCart();

  return (
    <article className="service-card" data-testid={`service-${service.id}`}>
      <img src={service.image} alt={service.name} loading="lazy" />
      <div>
        <p className="eyebrow">Deposit {formatCurrency(service.depositCents)}</p>
        <h3>{service.name}</h3>
        <p>{service.description}</p>
        <Button
          variant="secondary"
          data-testid={`add-service-${service.id}`}
          onClick={() =>
            cart.addItem({
              id: service.id,
              kind: "service",
              name: service.name,
              subtitle: "Booking deposit",
              priceCents: service.depositCents,
              image: service.image
            })
          }
        >
          Start booking
        </Button>
      </div>
    </article>
  );
}
